import {MatchmakingPriority} from '../../../../shared/matchmaking/MatchmakingEnums'
import {MatchmakingMatchTypes} from '@colonist/game-base-types'
import {MatchmakingPreferences, MatchmakingRequest, MatchmakingStatusUpdate} from '../../../../shared/matchmaking/MatchmakingInterfaces'
import {SocketMatchmakingSend} from '../../../shared/scripts/socket/SocketMatchmakingSend'
import {UIMatchmakingSearchMatchPopupView} from './UIMatchmakingSearchMatchPopupView'
import {UIManager} from '../ui_html/UIManager'
import {COLONIST_VERSION} from '@colonist/types'
import {getMatchTypeEligibilityAndCreatePopup, getMatchTypePlayerCount, shouldShowVideoAdBeforeEnteringRanked} from '../../../shared/scripts/matchmaking/MatchmakingUtilsClient'
import {socket} from '../../../shared/scripts/EntryShared'
import {UIAdBlockController} from '../ui_ad/UIAdBlockController'

export class UIMatchmakingFindGameController {
    private readonly searchMatchPopupView: UIMatchmakingSearchMatchPopupView
    private readonly uiManager: UIManager
    private selectedMatchType: MatchmakingMatchTypes | undefined

    constructor(uiManager: UIManager) {
        this.uiManager = uiManager
        this.searchMatchPopupView = new UIMatchmakingSearchMatchPopupView()
    }

    init() {
        socket.controller.registerSessionEstablishedObserver(() => {
            this.resendFindGame()
        })
    }

    private resendFindGame() {
        if(SocketMatchmakingSend.delayMatchmakingTimeout != undefined) return
        if(!this.searchMatchPopupView.isShowing()) return

        if(!SocketMatchmakingSend.lastMatchmakingRequest) {
            this.removePopups()
            return
        }

        SocketMatchmakingSend.sendFindGame()
    }

    updateMatchmakingStatus(matchmakingStatusUpdate: MatchmakingStatusUpdate) {
        if(this.selectedMatchType == undefined) return
        this.searchMatchPopupView.update(matchmakingStatusUpdate, this.selectedMatchType)
    }

    removePopups() {
        this.searchMatchPopupView.hide()
    }

    sendFindGameMessageToServer(selectedMatchType: MatchmakingMatchTypes) {
        const {isEligible, createPopup} = getMatchTypeEligibilityAndCreatePopup(selectedMatchType)
        createPopup?.()
        if(!isEligible) return

        const adblockIsActive = this.uiManager.adController.adblockState.isAdblockActive
        const matchmakingRequest: MatchmakingRequest = {
            matchPreferences: [],
            adblockEnabled: adblockIsActive,
            clientVersion: COLONIST_VERSION,
        }

        const preference: MatchmakingPreferences = {
            matchType: selectedMatchType,
            priority: MatchmakingPriority.High,
        }
        matchmakingRequest.matchPreferences.push(preference)
        this.selectedMatchType = selectedMatchType

        const rankedStates = this.uiManager.modeSelector.rankedStates

        const shouldShowVideoAd = shouldShowVideoAdBeforeEnteringRanked(selectedMatchType, rankedStates)

        if(shouldShowVideoAd) {
            if(adblockIsActive) {
                const noContinueAction = () => undefined
                UIAdBlockController.showDisableAdblockPopup(noContinueAction, false, false)
                this.removePopups()
                return
            }

            SocketMatchmakingSend.storeMatchmakingRequest(matchmakingRequest)
            this.uiManager.vliController?.startMatchmakingVideoAd()
            return
        }

        const initialPopupStatus: MatchmakingStatusUpdate = {
            numberOfPlayersFound: 1,
            totalNumberOfPlayersNeeded: getMatchTypePlayerCount(selectedMatchType),
        }
        this.searchMatchPopupView.update(initialPopupStatus, selectedMatchType)

        SocketMatchmakingSend.enterMatchmaker(matchmakingRequest)
    }
}
